<div class="mb-3">
  <button type="button" (click)="goToLogin()" class="btn-back">
    <i class="fas fa-arrow-left"></i> {{ translate.currentLang === 'en' ? 'Back to Login' : 'লগইনে ফিরে যান' }}
  </button>
</div>
<h1 class="global-title">{{ translate.currentLang === 'en' ? 'Forgot Your Password?' : 'পাসওয়ার্ড ভুলে গেছেন?' }}</h1>
<p class="global-subheading">{{ translate.currentLang === 'en' ? 'Enter your registered mobile number and email address. We\'ll send you a verification code to reset your password.' : 'আপনার নিবন্ধিত মোবাইল নম্বর ও ইমেইল ঠিকানা লিখুন। পাসওয়ার্ড রিসেট করতে আমরা আপনাকে একটি যাচাইকরণ কোড পাঠাব।' }}
</p>
<div class="account-form-wrapper">
  <!--  <form-->
  <!--    [hidden]="showForgotPasswordSignupForm"-->
  <!--    class="form reset-password-form user-form"-->
  <!--    #form="ngForm"-->
  <!--    [formGroup]="forgotPasswordForm"-->
  <!--    (ngSubmit)="onforgotPassword(form)"-->
  <!--    novalidate-->
  <!--  >-->
  <!--    <div class="row">-->
  <!--      <div class="col inner-fields">-->
  <!--        <div class="item-fields m-t-xl">-->
  <!--          <label>Please enter your NIC or Passport number to continue</label>-->
  <!--          <kendo-dropdownlist-->
  <!--            class="full-width"-->
  <!--            [formControl]="forgotPasswordForm.get('resident')"-->
  <!--            [data]="residentSelectData"-->
  <!--            [value]="'NIC'"-->
  <!--          >-->
  <!--          </kendo-dropdownlist>-->
  <!--          &lt;!&ndash; <form-select class="select-xs" [data]="residentSelectData" [control]="forgotPasswordForm.get('resident')" label="Select your Registration Method?"-->
  <!--        help="" [allowClear]="false"></form-select> &ndash;&gt;-->

  <!--          <form-text-->
  <!--            [hidden]="forgotPasswordForm.get('resident').value !== 'NIC'"-->
  <!--            [control]="forgotPasswordForm.get('nic')"-->
  <!--            label="Enter NIC Number"-->
  <!--            help=""-->
  <!--          >-->
  <!--            <span [hidden]="!forgotPasswordForm.get('nic').errors?.nic">9 digits followed by an English character OR 12 digits.</span>-->

  <!--            <span [hidden]="!forgotPasswordForm.get('nic').errors?.requireIfTrue">NIC Required</span>-->
  <!--          </form-text>-->
  <!--          <form-text-->
  <!--            [hidden]="forgotPasswordForm.get('resident').value !== 'Passport'"-->
  <!--            [control]="forgotPasswordForm.get('passport')"-->
  <!--            label="Enter Passport Number"-->
  <!--            help=""-->
  <!--            [maxLength]="12"-->
  <!--            [showErrors]="form.submitted"-->
  <!--          >-->
  <!--            <span [hidden]="!forgotPasswordForm.get('passport').errors?.passport">Passport is invalid.</span>-->

  <!--            <span [hidden]="!forgotPasswordForm.get('passport').errors?.requireIfTrue">Passport Required</span>-->
  <!--          </form-text>-->

  <!--          <form-text-->
  <!--            *ngIf="forgotPasswordForm.get('resident').value === 'BRN'"-->
  <!--            [control]="forgotPasswordForm.get('brn')"-->
  <!--            label="Enter BRN Number"-->
  <!--            help=""-->
  <!--          >-->
  <!--            <span [hidden]="!forgotPasswordForm.get('brn').errors?.requireIfTrue">BRN Required</span>-->
  <!--          </form-text>-->

  <!--          <div class="alert alert-danger" [hidden]="!userAvailabilityError">-->
  <!--            <span [hidden]="!forgotPasswordForm.get('nic').value">NIC you have entered is not registered in our system</span>-->
  <!--            <span [hidden]="!forgotPasswordForm.get('passport').value"-->
  <!--              >Passport Number you have entered is not registered in our system</span-->
  <!--            >-->
  <!--          </div>-->
  <!--          <div class="row">-->
  <!--            <div class="col-lg-6 col-md-12 col-12">-->
  <!--              <span class="loader inline-loader" [hidden]="!checkuserAvailability"></span>-->
  <!--              <button type="submit" class="w-100 mt-1 text-center btn-md btn-primary">Submit</button>-->
  <!--            </div>-->
  <!--            <div class="col-lg-6 col-md-12 col-12">-->
  <!--              <button type="button" class="w-100 mt-1 text-center btn-md btn-primary-inverse" [routerLink]="['/login']">Back</button>-->
  <!--            </div>-->
  <!--          </div>-->
  <!--        </div>-->
  <!--      </div>-->
  <!--    </div>-->
  <!--  </form>-->

  <div class="user-registraion form" *ngIf="showForgotPasswordSignupForm">
    <app-forgot-password-sign-up [fields]="forgotPasswordForm.value"
      (changeNIC)="changeNIC($event)"></app-forgot-password-sign-up>
  </div>
  <div class="powered-by text-center mt-2">
    <div>
      {{ translate.currentLang === 'en' ? 'Powered by' : 'পাওয়ার্ড বাই' }}
      <a href="https://cal.lk" target="_blank">CAL</a> | <a href="/terms-and-conditions">{{ translate.currentLang === 'en' ? 'Disclaimer' : 'দাবিত্যাগ' }}</a>
    </div>
  </div>
</div>